import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { showMsg } from '../../services/library';
import ImportService from '../../services/importerService';
import { appConf } from '../../appConf';

const REQ_IMPORT = 'mavis/';

export const fetchImportTreeDataReq = createAsyncThunk(
  `${REQ_IMPORT}getnode`,
  async (data, { rejectWithValue }) => {
    try {
      const res = await ImportService.getTreeData(data);
      if (res.status) {
        return res.data[0] || null;
      } else {
        showMsg(res.errors, 'error');
        return rejectWithValue(res.errors);
      }
    } catch (err) {
      showMsg(err, 'error');
      return rejectWithValue(err);
    }
  }
);

const mavisSlice = createSlice({
  name: 'mavisSlice',
  initialState: {
    page: 1,
    totalRecords: 0,
    limit: appConf.pageLimit,
    selectedKey: 'root',
    data: {},
    isLoaded: false,
    search: ''
  },
  reducers: {
    handlePage: (state, action) => {
      state.page = action.payload;
    },
    handleTotalRecords: (state, action) => {
      state.totalRecords = action.payload;
    },
    handleLimit: (state, action) => {
      state.limit = action.payload;
    },
    handleSelectedKey: (state, action) => {
      state.selectedKey = action.payload;
    },
    handleData: (state, action) => {
      state.data = action.payload;
    },
    handleIsLoaded: (state, action) => {
      state.isLoaded = action.payload;
    },
    handleSearch: (state, action) => {
      state.search = action.payload;
    }
  },
  extraReducers: (/* builder */) => {
    // builder
    // .addCase(fetchImportTreeDataReq.pending, (state, action) => {
    //   state.isLoaded = false;
    //   state.data = [];
    // })
    // .addCase(fetchImportTreeDataReq.fulfilled, (state, action) => {
    //   console.log(action.payload);
    //   const { resData, resPayload } = action.payload;
    //   const { path } = resPayload;
    //   let dataKey = path === '' ? 'root' : path;
    //   let nodeData = this.state.data;
    //   nodeData[dataKey] = resData.nodes;
    //   let stateData = { data: nodeData, selectedKey: 'root', isLoaded: true, clearSearch: true };
    //   if (dataKey === 'root') {
    //     stateData.page = resData.page + 1;
    //     stateData.totalRecords = resData.total;
    //     stateData.limit = resData.limit;
    //   }
    //   this.setState(stateData, () => {
    //     if (localStorage.getItem(STORAGE_EXPORTDATA) !== null) {
    //       this.getIndex();
    //     }
    //     if (current !== null) {
    //       this.toggleNode(current);
    //     }
    //   });
    // })
    // .addCase(fetchImportTreeDataReq.rejected, (state, action) => {
    //   state.isLoaded = true;
    //   state.data = [];
    // });
  }
});

export const {
  handlePage,
  handleTotalRecords,
  handleLimit,
  handleSelectedKey,
  handleData,
  handleIsLoaded,
  handleSearch,
  handleClearSearch,
  handleMoveToggle,
  handleMergeTwoVehToggle,
  handleMergeVehId,
  handleMergeVin,
  handleMoveToPath,
  handleRenameDialouge,
  handleRenameData,
  handleIsSwapOpen,
  handleSwapData,
  handleIsEditing,
  handleFromDate,
  handleToDate,
  handleSearchData,
  handleShowVinList
} = mavisSlice.actions;

export default mavisSlice.reducer;
